import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
import { type EcomSearch, ecomSearchSchema } from "@/features/reports/ecom-model";
import { ensureElementVisible } from "@/lib/route-guards";

const EcomPage = lazy(() =>
	import("@/features/reports/ecom-page").then((m) => ({ default: m.EcomPage })),
);
export const Route = createFileRoute("/_auth/raporty/ecom")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(context.queryClient, "sidebar.raporty.ecom", location.pathname);
	},
	validateSearch: (search: Record<string, unknown>): EcomSearch => ecomSearchSchema.parse(search),
	component: EcomPage,
});
